import type { SearchParams } from '@api/constants';
import { createPath, parsePath, type Path, type To } from 'react-router-dom';

export function preserveCurrentSearch(to: To, searchParams: URLSearchParams): Partial<Path> {
  const target = typeof to === 'string' ? parsePath(to) : { ...to };

  if (target.search !== undefined) {
    return target;
  }

  const query = searchParams.toString();
  return query ? { ...target, search: `?${query}` } : target;
}

export function withSearchParam(
  to: string,
  searchParams: URLSearchParams,
  key: SearchParams,
  value: string,
): Partial<Path> {
  const query = new URLSearchParams(searchParams);
  query.set(key, value);
  return { ...parsePath(to), search: `?${query}` };
}

export function omitSearchParam(searchParams: URLSearchParams, key: SearchParams): URLSearchParams {
  const query = new URLSearchParams(searchParams);
  query.delete(key);
  return query;
}

export function createHrefWithCurrentSearch(to: To, searchParams: URLSearchParams) {
  return createPath(preserveCurrentSearch(to, searchParams));
}
